<span class="copyright">&copy; {{currentYear}}. All rights reserved.</span>
